// Environment-aware API base URLs.
//   `npm run dev`   → import.meta.env.DEV = true  → talk to the LOCAL backend
//   `npm run build` → import.meta.env.DEV = false → talk to PRODUCTION (aonelao.com)
// So local testing hits your local servers and the deployed bundle hits prod —
// no manual switching needed.
const isDev = import.meta.env.DEV;

// const ApiLink = 'https://172.21.4.70:5003';
// const ApiLink = 'https://application.besttelecom.la:5003';
// Production: served behind Nginx (443 -> backend :5003), same origin as the SPA.
const ApiLink = isDev ? 'http://localhost:5003' : 'https://aonelao.com';
export default ApiLink;

// Standalone whatsappapi service (per-branch WhatsApp Web). Shares the ERP
// session token. Production: exposed via Nginx on a dedicated HTTPS port (8443 -> :5001).
export const WhatsAppApiLink = isDev ? 'http://localhost:5001' : 'https://aonelao.com:8443';
